export { findElementRecursive } from '@fluentui/dom-utilities';
